<template>
  <ul role="menubar">
    <li><span>Display:</span></li>
    <li role="none">
      <button
        class="btn base-btn-primary base-btn-primary--dark high-contrast-btn active"
        ref="defaultBtn"
        @click="setDefaultContrast"
      >
        Default
      </button>
    </li>
    <li role="none">
      <button
        class="btn base-btn-primary base-btn-primary--light high-contrast-btn"
        ref="highContrastBtn"
        @click="setHighContrast"
      >
        High Contrast
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  methods: {
    setDefaultContrast() {
      document.body.classList.remove('high-contrast')
      this.$refs.defaultBtn.classList.add('active')
      this.$refs.highContrastBtn.classList.remove('active')
      document.cookie = 'highContrast=false; path=/'
    },

    setHighContrast() {
      document.body.classList.add('high-contrast')
      this.$refs.defaultBtn.classList.remove('active')
      this.$refs.highContrastBtn.classList.add('active')
      document.cookie = 'highContrast=true; path=/'
    },
  },

  mounted() {
    // get highContrast cookie
    // eslint-disable-next-line
    var cookies = decodeURIComponent(document.cookie).split(';').map(cookie => cookie.trim())
    var highContrast = cookies.includes('highContrast=true')
    if (highContrast) {
      this.setHighContrast()
    }
  },
}
</script>
